import React from 'react';
import Container from './Container.js';
import ContactTeaserCard from './ContactTeaserCard.js';
const ContactTeaser = ({
  headline = '',
  img = null,
  contactCard = []
}) => /*#__PURE__*/React.createElement(Container, {
  standout: true
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-contact-teaser"
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-contact-teaser__container"
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-contact-teaser__container__headline"
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-contact-teaser__container__headline__title"
}, /*#__PURE__*/React.createElement("h2", null, headline)), /*#__PURE__*/React.createElement("div", {
  className: "ebds-contact-teaser__container__headline__image"
}, img)), /*#__PURE__*/React.createElement("div", {
  className: "ebds-contact-teaser__container__cards"
}, contactCard.map((card, index) => /*#__PURE__*/React.createElement(ContactTeaserCard, Object.assign({
  key: index
}, card)))))));
export default ContactTeaser;